<template>
    <h1>Modelos de Avaliação</h1>
    <AssessmentModelManagementTable />
</template>

<script setup>
import AssessmentModelManagementTable from "@/components/assessments/models/AssessmentModelManagementTable.vue";
</script>
